// @ts-nocheck
/* eslint-disable */
import React from 'react';

import Button from '../../common/components/core/Button';
import Link from '../../common/components/core/Link';
import { ImageService } from '../../main/services/ImageService/ImageService';

export default class ScreenSsoLogin extends React.Component {
  constructor(props) {
    super(props);

    const { pathname } = location;

    if (pathname.indexOf('error') > -1) {
      this.noApp = true;
    }
  }

  render() {
    return (
      <div className="loggedout--container">
        <img src={ImageService.getImageUrl('/static/images/branch-logos/branch-logo_dark.svg')} />
        <div className="login-container">
          <div className="auth-header">
            <h1 className="create-account h_fw-700">Sign in</h1>
          </div>

          <div className="sso-content">
            <div className="h_fw-300 h_fz-body1">Welcome Back!</div>

            <div className="h_my-20">
              <Button
                href={`${location.origin}/dashboard`}
                newTab={false}
                className="btn-signup"
                disabled={this.noApp}
                testid="sso-btn"
              >
                <i className="material-icons h_fz-body1 h_va-tt h_mend-10">vpn_key</i>
                Single Sign On
              </Button>
            </div>

            <div className="h_fz-body2 h_pt-20">
              <span>Questions? We are here to </span>
              <Link href="https://support.branch.io" testid="help-support-link">
                help
              </Link>
              <span>.</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
